import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '漫画分类',
    links: [
      { label: '奇幻冒险', href: '/category/fantasy' },
      { label: '恋爱甜宠', href: '/category/romance' },
      { label: '动作热血', href: '/category/action' },
      { label: '悬疑惊悚', href: '/category/thriller' },
    ],
  },
  {
    title: '帮助中心',
    links: [
      { label: '关于我们', href: '/about' },
      { label: '常见问题', href: '/about#faq' },
      { label: '阅读指南', href: '/about' },
      { label: '版权声明', href: '/about' },
    ],
  },
  {
    title: '联系方式',
    links: [
      { label: '客服邮箱：hello@caishenlicai.com', href: '#' },
      { label: '商务合作：hello@caishenlicai.com', href: '#' },
      { label: '工作时间：周一至周五 9:00-18:00', href: '#' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-accent-950">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <h3 className="text-white text-2xl font-bold font-heading mb-4">韩漫大全</h3>
            <p className="text-foreground-400 text-sm leading-relaxed mb-6">
              最新最全的正版韩国漫画在线阅读平台。每日更新，高清画质，为您带来极致的漫画阅读体验。
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full border border-foreground-500/30 text-foreground-400 hover:text-white hover:border-white/50 transition-colors cursor-pointer" aria-label="微博" rel="nofollow">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full border border-foreground-500/30 text-foreground-400 hover:text-white hover:border-white/50 transition-colors cursor-pointer" aria-label="微信" rel="nofollow">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full border border-foreground-500/30 text-foreground-400 hover:text-white hover:border-white/50 transition-colors cursor-pointer" aria-label="B站" rel="nofollow">
                <i className="ri-bilibili-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full border border-foreground-500/30 text-foreground-400 hover:text-white hover:border-white/50 transition-colors cursor-pointer" aria-label="小红书" rel="nofollow">
                <i className="ri-red-packet-line text-lg"></i>
              </a>
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-white text-sm font-semibold mb-4 uppercase tracking-wider">{group.title}</h4>
              <ul className="flex flex-col gap-3">
                {group.links.map((link) => (
                  <li key={link.label}>
                    {link.href.startsWith('/') ? (
                      <Link to={link.href} className="text-foreground-400 text-sm hover:text-white transition-colors cursor-pointer">
                        {link.label}
                      </Link>
                    ) : (
                      <span className="text-foreground-400 text-sm">{link.label}</span>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div className="border-t border-foreground-700/20">
        <div className="w-full px-4 md:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-foreground-500 text-xs">
            &copy; {new Date().getFullYear()} 韩漫大全 HanManDaQuan. 版权所有。
          </p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-foreground-500 text-xs hover:text-foreground-300 transition-colors cursor-pointer" rel="nofollow">隐私政策</a>
            <a href="#" className="text-foreground-500 text-xs hover:text-foreground-300 transition-colors cursor-pointer" rel="nofollow">服务条款</a>
            <a href="#" className="text-foreground-500 text-xs hover:text-foreground-300 transition-colors cursor-pointer" rel="nofollow">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}